<template>
    <div class="advertisement">
        <header>
            <div class="head">
                <div @click="goback">
                    <img src="@/assets/hotel/img/micon/back_cb.png" alt="back">
                </div>
                <div>
                    <p>广告页</p>
                </div>
            </div>
        </header>
        <main>
            <img src="https://article-qiniu.shall-buy.com/%E9%85%92%E5%BA%97h5.png" alt="">
        </main>
    </div>
</template>

<script>
    export default {
        methods: {
            goback(){
                history.go(-1);
            }
        },
    }
</script>

<style lang="less" >
    html {
        font-size: calc(var(--sizeScale2)*10px);
    }
    .advertisement{
        padding-top: 7.8rem;
        header{
            padding-top: 4.4rem;
            background-color: #fff;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            .head{
                position: relative;
                height: 4.4rem;
                div{
                    font-size: 0;
                    &:nth-of-type(1){
                        position: absolute;
                        left: 1.6rem;
                        top: 50%;
                        transform: translateY(-50%);
                        img{
                            width: 2rem;
                            height: 2rem;
                        }
                    }
                    &:nth-of-type(2){
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateX(-50%) translateY(-50%);
                        font-size: 1.5rem;
                    }
                }
            }
        }
        main{
            font-size: 0;
            img{
                width: 100%;
            }
        }
    }
</style>